/* eslint-disable jsx-a11y/alt-text */
import React, { memo, useState } from "react";

const ImagesConfig = memo(({ image, imageDefault, width, height }) => {
	const [isExists, setIsExists] = useState(false);
	return (
		<img
			src={isExists ? (image ? image : imageDefault) : imageDefault}
			width={width}
			height={height}
			onLoad={() => {
				setIsExists(true);
			}}
			onError={({ currentTarget }) => {
				currentTarget.onerror = null; // prevents looping
				currentTarget.src = imageDefault;
				currentTarget.alt = imageDefault;
			}}
		/>
	);
});

export default ImagesConfig;
